import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import authReducer from './authReducer';
import usersReducer from './usersReducer';
import simsReducer from './simsReducer';
import websocketReducer from './websocketReducer';
import devicesReducer from './devicesReducer';
import ticketingReducer from './ticketingReducer';
import performancesReducer from './performancesReducer';
import notificationsReducer from './notificationsReducer';
import { kpiReducer } from './kpiReducer';

const createRootReducer = (history) =>
    combineReducers({
        router: connectRouter(history),
        auth: authReducer,
        user: usersReducer,
        sims: simsReducer,
        websocket: websocketReducer,
        devices: devicesReducer,
        ticketing: ticketingReducer,
        performances: performancesReducer,
        notifications: notificationsReducer,
        kpi: kpiReducer
    });

export default createRootReducer;
